import { Type } from 'class-transformer';
import { IsArray, IsDateString, IsOptional, IsString, ValidateNested } from 'class-validator';
import { PublicCounterRegisterEntryDto } from './public-counter-register-entry.dto';

/**
 * No `tenantId`, no internal ids beyond what the public page needs — same
 * minimization discipline as `lot-public.controller.ts`.
 */
export class PublicCounterRegisterResponseDto {
  @IsString()
  businessDisplayName!: string;

  @IsDateString()
  generatedAt!: string;

  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => PublicCounterRegisterEntryDto)
  entries!: PublicCounterRegisterEntryDto[];

  /**
   * App-relative path (never an absolute storage/presigned URL) to the PDF
   * currently in force for this menu, e.g.
   * `/public/counter-register/{slug}/download`. Built from the same `slug`
   * already public on this response — no tenant or document id ever appears
   * in it (art. 19 comma 3 minimization discipline, same as every other
   * field here). When the persisted PDF is still being generated, the same
   * route renders the current composed register on demand.
   */
  @IsOptional()
  @IsString()
  pdfDownloadUrl?: string;
}
